// extracted by mini-css-extract-plugin
export default {"radio":"RadioGroupCo_radio__nwG5+","radio__input":"RadioGroupCo_radio__input__AkQjE","radio__label":"RadioGroupCo_radio__label__J0HOB"};